var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "header" },
      _vm._l(_vm.headerFields, function(f) {
        return _c("div", { style: _vm.calcWidth(f) }, [
          _vm._v("\n      " + _vm._s(f.display) + "\n    ")
        ])
      })
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "body" },
      _vm._l(_vm.rows, function(r) {
        return _c(
          "div",
          {
            key: r.id,
            staticClass: "row",
            on: {
              click: function($event) {
                _vm.rowSelected(r)
              }
            }
          },
          _vm._l(_vm.headerFields, function(f) {
            return _c("div", { style: _vm.calcWidth(f) }, [
              _vm._v("\n        " + _vm._s(r[f.field]) + "\n      ")
            ])
          })
        )
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-87dc9032", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87dc9032","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aGrid.vue
// module id = HQfR
// module chunks = 1